import React, { createContext, useContext, useMemo } from "react";
import * as Option from "@utils/Option";
import type { OptionTs } from "@ps-bridge/interop";
import type { AdminPlanClient } from "@ps-bridge/clients/adminPlan";
import { createDefaultAdminPlanClient, createStubAdminPlanClient } from "@src/purescript/interop";
import { enabledFeatures, FeaturesEnum } from "@utils/enabledFeatures";
import { requireContext } from "@contexts/requireContext";

const AdminPlanClientContext = createContext<OptionTs<AdminPlanClient>>(Option.none());

export const AdminPlanClientProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const adminPlanClient = useMemo<AdminPlanClient>(() => {
    if (enabledFeatures[FeaturesEnum.StubClients]) {
      return createStubAdminPlanClient;
    }
    return createDefaultAdminPlanClient;
  }, []);

  const contextValue = useMemo(() => Option.some(adminPlanClient), [adminPlanClient]);

  return (
    <AdminPlanClientContext.Provider value={contextValue}>
      {children}
    </AdminPlanClientContext.Provider>
  );
};

export const useAdminPlanClient = (): AdminPlanClient => {
  return requireContext(
    useContext(AdminPlanClientContext),
    "useAdminPlanClient must be used within an AdminPlanClientProvider",
  );
};
